<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
        :height="height" :class="classes" class="fill-current">
        <path d="M 12 2 A 2 2 0 0 0 10 4 L 10 9.0039062 L 2 14 L 2 16 L 10 13.507812 L 10 19.003906 L 8 20.5 L 8 22 L 12 21 L 16 22 L 16 20.5 L 14 19.003906 L 14 13.507812 L 22 16 L 22 14 L 14 9.0039062 L 14 4 A 2 2 0 0 0 12 2 z"/>
    </svg>
</template>

<script>
export default {
    props: [ 'height', 'classes' ]
}
</script>